import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { usePiiReminder } from '@/hooks/usePiiReminder';

export const PiiReminderDialog = () => {
  const { showReminder, acknowledge } = usePiiReminder();

  if (!showReminder) return null;

  return (
    <AlertDialog open={showReminder}>
      <AlertDialogContent onEscapeKeyDown={(e) => e.preventDefault()}>
        <AlertDialogHeader>
          <AlertDialogTitle>Mundu að nota ekki persónugreinanlegar upplýsingar</AlertDialogTitle>
          <AlertDialogDescription>
            Þegar þú talar inn í Skríbuna, mundu að nota ekki nöfn sjúklinga, kennitölur eða aðrar persónugreinanlegar
            upplýsingar.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={acknowledge}>Ég skil</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
